import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DataEncryptDecryptService } from '../../shared/services/dataEncryptionDecryption.service';

@Injectable({
  providedIn: 'root'
})
export class CostReportService {

  private apiUrl: string = environment.apiUrl + 'api/reports/';

  constructor(private http: HttpClient, private dataEncryption:DataEncryptDecryptService) {
  }

  insertCostReportData(passphrase: string, rows: any[]): Observable<any> {
    const url = `${this.apiUrl}payroll/import`;
    const encryptedPassphrase = this.dataEncryption.encryption(passphrase);
    const data = { passphrase: encryptedPassphrase, rows };
    return this.http.post<any>(url, data);
  }

  insertDefaultCostReportData(passphrase: string, rows: string): Observable<any> {
    const url = `${this.apiUrl}default/payroll/import`;
    const encryptedPassphrase = this.dataEncryption.encryption(passphrase);
    const data = { passphrase: encryptedPassphrase, rows };
    return this.http.post<any>(url, data);
  }

  updatePassphrase(currentPass: string, newPass: string) {
    const encryptedCurrentPass = this.dataEncryption.encryption(currentPass);
    const encryptedNewPass = this.dataEncryption.encryption(newPass);
    const url = `${this.apiUrl}passphrase/update`;
    return this.http.post(url, { currentPass: encryptedCurrentPass, newPass: encryptedNewPass });
  }

  insertProjectBainTargetsData(rows: any[]): Observable<any> {
    const url = `${this.apiUrl}project-bain-targets/import`;
    return this.http.post<any>(url, { rows });
  }

  insertBainTargetsData(rows: any[]): Observable<any> {
    const url = `${this.apiUrl}bain-targets/import`;
    return this.http.post<any>(url, { rows });
  }

  fetchMatrixData(flag: any): Observable<any> {
    const Flag = flag;
    const url = `${this.apiUrl}viewMatrixData`;
    return this.http.post<any>(url, { Flag });
  }

  insertPracticeAreaData(rows: any[]): Observable<any> {
    const url = `${this.apiUrl}practice-areas/import`;
    return this.http.post<any>(url, { rows });
  }

  getLastUpdatedOn(flag: string): Observable<any> {
    const Flag = flag;
    const url = `${this.apiUrl}last-updated`;
    return this.http.post<any>(url, { Flag });
  }
}
